export default __webpack_public_path__ + "static/media/APY yellow.3f297d21.png";